import React from "react";
import styles from "./BotTableHeader.module.css";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {BotTableSortingField} from "../../../../../api/generated";
import {SortableHeaderCell, TableSort} from "../../../../elements/sortableHeaderCell/SortableHeaderCell";
import {botTableRequestSelector, updateBotTableRequest} from "../../botListSlice";

export const BotTableHeader: React.FC = () => {
    const dispatch = useAppDispatch()
    const {sortBy, sortDirection} = useAppSelector(botTableRequestSelector)
    const sort: TableSort<BotTableSortingField> = {sortBy, sortDirection}

    const handleSort = (nextSort: TableSort<BotTableSortingField>) => {
        dispatch(updateBotTableRequest(nextSort))
    }

    return <div className={styles.wrapper}>
        <SortableHeaderCell className={styles.dealerCell} title={"Dealer"} sortKey={BotTableSortingField.Name} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.websiteCell} title={"Website"} sortKey={BotTableSortingField.Website} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.convCountAllCell} title={"Conversation count (all time)"} sortKey={BotTableSortingField.ConversationCountAllTime} sort={sort} onSort={handleSort}/>
        <span className={styles.convCountMonthlyCell}>Conversation count (monthly)</span>
        <SortableHeaderCell className={styles.usedConvosCell} title={"% of used convos"} sortKey={BotTableSortingField.UsedConversationPercentage} sort={sort} onSort={handleSort}/>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
